"use client";

import { Button, Input } from "@relume_io/relume-ui";
import React from "react";

export function NewsletterCta() {
  return (
    <section id="relume" className="relative px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container">
        <div className="w-full max-w-lg">
          <h2 className="mb-5 text-5xl font-bold text-text-alternative md:mb-6 md:text-7xl lg:text-8xl">
            Stay Updated with Our Substack
          </h2>
          <p className="text-text-alternative md:text-md mb-6">
            Subscribe to our Substack for the latest insights on AI consulting and Microsoft technologies.
          </p>
          <iframe
            src="https://omnigeist.substack.com/embed"
            width="100%"
            height="320"
            style={{ border: '1px solid #EEE', background: 'white' }}
            frameBorder="0"
            scrolling="no"
          ></iframe>
        </div>
      </div>
      <div className="absolute inset-0 -z-10">
        <img
          src="/assets/svg/SubstackHeroBackground.svg"
          className="size-full object-cover"
          alt="Newsletter background pattern"
        />
      </div>
    </section>
  );
}